import createIcon from '../../createIcon';

/**
 * @component @name Schema
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNSA5VjExSDEwLjVWOUg4VjdIMTAuNVYxSDMuNVY3SDZWOUgzLjVWMTVINlYxN0gzLjVWMjNIMTAuNVYxN0g4VjE1SDEwLjVWMTNIMTMuNVYxNUgyMC41VjlIMTMuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Schema = createIcon('Schema', [
  [
    'path',
    {
      d: 'M13.5 9V11H10.5V9H8V7H10.5V1H3.5V7H6V9H3.5V15H6V17H3.5V23H10.5V17H8V15H10.5V13H13.5V15H20.5V9H13.5Z',
      key: '1i9n1y',
    },
  ],
]);

export default Schema;
